const stripCountry = (description: string) => description.replace(/, United States|, USA/, '');

export { stripCountry };
